<script setup lang="ts">

import { FiltersBar } from '@shared/ui/filters'
import { AppSelect } from '@shared/ui/selects'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary } from '@shared/ui/buttons'

import { useFiltersApiTokens } from '../../model/api-tokens/filters-api-tokens.hook'

defineOptions({
  name: 'FiltersApiTokens',
})

const {
  refUserId,
  refSearch,
  userOptions,
  canFilterByUser,
  isLoading,
  submitSearch,
  openCreateModal,
} = useFiltersApiTokens()
</script>

<template>
  <FiltersBar
    class="box-filters-api-tokens"
    :loading="isLoading"
    :clearable="false"
    @click:submit="submitSearch"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        label="Search"
        placeholder="Search"
      />

      <AppSelect
        v-if="canFilterByUser"
        v-model="refUserId"
        :options="userOptions"
        label="User"
        placeholder="All users"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <BtnPrimary
        text="Create token"
        color="emerald"
        element-width="auto"
        :disabled="isLoading"
        @click="openCreateModal"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersApiTokens.scss" />
